import * as React from 'react';
import { SystemIconType } from '../types';
/**
 * @deprecated Please use @fiverr-private/visuals package.
 */
const FiverrIcon = ({ size = 16, color = 'currentFill' }: SystemIconType) => (
    <svg width={size}
        height={size}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        fill={color}>
        <path d="M24 12c0-6.627-5.373-12-12-12S0 5.373 0 12s5.373 12 12 12 12-5.373 12-12Zm-6.7 6.36H14.15v-6.974h-3.016v6.974h-3.17v-6.974H6.166v-2.58h1.797v-.784c0-2.044 1.547-3.439 3.847-3.439h2.34v2.58h-1.817c-.735 0-1.2.4-1.2 1.05v.593h6.168v9.554Z"/>
    </svg>
);
FiverrIcon.displayName = 'FiverrIcon';
export default FiverrIcon;
